import { render, staticRenderFns } from "./coloredChipTemplate.vue?vue&type=template&id=07d63b81&"
import script from "./coloredChipTemplate.vue?vue&type=script&lang=js&"
export * from "./coloredChipTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports